import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/marketing/landing-v2/Landing2Page.tsx");
